import React, {useState, Fragment, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {makeStyles} from "@material-ui/core/styles";
import Fab from "@material-ui/core/Fab";
import Box from "@material-ui/core/Box";
import Checkbox from "@material-ui/core/Checkbox";
import Chip from "@material-ui/core/Chip";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import StorageIcon from "@material-ui/icons/Storage";
import AttachmentChip from "../../../Chip/AttachmentChip";
import FilterListIcon from "@mui/icons-material/FilterList";
import {
    circulationFileZoneContentStyle
} from "../../../../styles/jss/components/circulation/circulationFileZoneContentStyle";
import {fileDownload} from "../../../../dataSource/fileManager";
import AttachmentDeletedChip from "../../../Chip/AttachmentDeletedChip";

const useStyles = makeStyles((theme) => circulationFileZoneContentStyle(theme));

const PilFileZoneContentSupportDoc = (props) => {
    const docTypes = [
        {value: "", label: ""},
        {value: "ochart", label: "O-chart and Manpower Schedule"},
        {value: "tender", label: "Tender and Design Information Schedule"},
        {value: "tempwork", label: "Temp-work Schedule"},
        {value: "plant", label: "Plant Schedule"},
        {value: "others", label: "Others (e.g. Construction Plan, Program and Method Presentation, etc.)"},
    ];

    const pilDataRedux = useSelector((state) => state.pilDetailsRedux);
    const classes = useStyles();
    const [showFilter, setShowFilter] = useState(false);
    const [filterVersion, setFilterVersion] = useState("");
    const [filterStatus, setFilterStatus] = useState("")
    const [filterDocTypes, setFilterDocTypes] = useState([]);
    let [filteredList, setFilteredList] = useState([]);
    const [resetFlag, setResetFlag] = useState(false);
    const {open, fileRemoveAction, viewFileAction, openFileManagerDialog, fileType, uploadable, lock} =
        props;
    const downloadFileAction = (fileCat, fileSeq) => {
        fileDownload(fileCat, fileSeq).then((res) => {
            console.log(
                "*****************************************************************************"
            );
            console.log("System Module: Document Submission");
            console.log("Message: File download successful.");
            console.log(
                "*****************************************************************************"
            );
        });
    };

    useEffect(() => {
        setFilteredList(
            pilDataRedux.uploadFiles.filter(
                (a) => a.type !== "stage1" && a.type !== "stage2" && a.type === fileType
            )
        );
    }, [resetFlag, pilDataRedux]);


    let versionList = [
        ...new Set(
            pilDataRedux.uploadFiles
                .filter((a) => a.type !== "stage1" && a.type !== "stage2" && a.type === fileType)
                .map((obj, index) => obj.version)
                .sort()
        ),
    ];

    const handleFilterMultiDropdownChange = (event) => {
        if (event.target.value[event.target.value.length - 1] === "all") {
            if (filterDocTypes.length === 0) {
                setFilterDocTypes(docTypes.map((obj) => obj.label));
            } else {
                setFilterDocTypes([]);
            }
        } else {
            setFilterDocTypes(event.target.value);
        }
    };

    const saveFilter = () => {
        setFilteredList(
            pilDataRedux.uploadFiles.length > 0 &&
            pilDataRedux.uploadFiles
                .filter((a) => a.type !== "stage1" && a.type !== "stage2" && a.type === fileType)
                .filter((b) =>
                    filterVersion !== "" ? b.version === filterVersion.toString() : true
                )
                .filter((b) =>
                    filterStatus !== "" ? b.status === filterStatus.toString() : true
                )
                .filter((obj) => {
                    let docValue = docTypes.find(
                        (jobj) => jobj.value === obj.type
                    ).label;
                    return filterDocTypes.length !== 0
                        ? filterDocTypes.includes(docValue)
                        : true;
                })
        );
    };

    const resetFilter = () => {
        setFilterStatus("")
        setFilterVersion("");
        setFilterDocTypes([]);
        setResetFlag((prev) => !prev);
    };

    return (
        <Fragment>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Button
                                variant="outlined"
                                color="primary"
                                startIcon={<FilterListIcon/>}
                                style={{margin: "8px"}}
                                onClick={() => {
                                    setShowFilter((prev) => !prev);
                                }}
                            >
                                Filter
                            </Button>
                        </Grid>
                        {showFilter && (
                            <Grid item xs={12}>
                                <Box
                                    style={{
                                        border: "1px solid #acbec3",
                                        borderRadius: "5px",
                                        minHeight: "150px",
                                    }}
                                >
                                    <Grid style={{padding: "16px"}} container spacing={1}>
                                        <Grid item xs={12}>
                                            <FormControl
                                                size="small"
                                                variant="outlined"
                                                style={{minWidth: 120, width: "100%", margin: 0}}
                                            >
                                                <InputLabel id="demo-select-small">Version</InputLabel>
                                                <Select
                                                    id={"filter"}
                                                    name={"filter"}
                                                    label={"Version"}
                                                    MenuProps={{
                                                        anchorOrigin: {
                                                            vertical: "bottom",
                                                            horizontal: "left",
                                                        },
                                                        transformOrigin: {
                                                            vertical: "top",
                                                            horizontal: "left",
                                                        },
                                                        getContentAnchorEl: null,
                                                    }}
                                                    fullWidth
                                                    value={filterVersion}
                                                    onChange={(e) => {
                                                        setFilterVersion(e.target.value);
                                                    }}
                                                    variant={"outlined"}
                                                    size="small"
                                                >
                                                    {versionList.map((obj, index) => {
                                                        return (
                                                            <MenuItem key={index} value={obj}>
                                                                {obj}
                                                            </MenuItem>
                                                        );
                                                    })}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl
                                                size="small"
                                                variant="outlined"
                                                style={{minWidth: 120, width: "100%", margin: 0}}
                                            >
                                                <InputLabel id="demo-select-small">Status</InputLabel>
                                                <Select
                                                    id={"filter"}
                                                    name={"filter"}
                                                    label={"Status"}
                                                    MenuProps={{
                                                        anchorOrigin: {
                                                            vertical: "bottom",
                                                            horizontal: "left",
                                                        },
                                                        transformOrigin: {
                                                            vertical: "top",
                                                            horizontal: "left",
                                                        },
                                                        getContentAnchorEl: null,
                                                    }}
                                                    fullWidth
                                                    value={filterStatus}
                                                    onChange={(e) => {
                                                        setFilterStatus(e.target.value);
                                                    }}
                                                    variant={"outlined"}
                                                    size="small"
                                                >
                                                    <MenuItem value={"Y"}>
                                                        Activate
                                                    </MenuItem>
                                                    <MenuItem value={"N"}>
                                                        Deleted
                                                    </MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        {/*
                                <Grid item xs={12}>
                      <FormControl
                        size="small"
                        variant="outlined"
                        style={{ minWidth: 120, width: "100%", margin: 0 }}
                      >
                        <InputLabel id="demo-select-small">
                          Document Type
                        </InputLabel>
                        <Select
                          labelId="demo-select-small"
                          id="demo-select-small"
                          value={filterDocTypes}
                          label="Document Type"
                          style={{ width: "100%" }}
                          MenuProps={{
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "left",
                            },
                            transformOrigin: {
                              vertical: "top",
                              horizontal: "left",
                            },
                            getContentAnchorEl: null,
                          }}
                          onChange={handleFilterMultiDropdownChange}
                          multiple
                          renderValue={(selected) => (
                            <Box
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 0.5,
                              }}
                            >
                              {selected
                                .filter((obj) => obj !== "")
                                .map((value) => (
                                  <Chip
                                    size={"small"}
                                    key={value}
                                    label={value}
                                    style={{ margin: "4px" }}
                                  />
                                ))}
                            </Box>
                          )}
                        >
                          <MenuItem
                            key={"All"}
                            value={"all"}
                            style={{ padding: "4px 0 4px 0" }}
                          >
                            <Checkbox
                              checked={
                                filterDocTypes.length === docTypes.length
                              }
                            />
                            {"Choose All"}
                          </MenuItem>
                          {docTypes
                            .filter((obj) => obj.value !== "")
                            .map((name, index) => (
                              <MenuItem
                                key={index}
                                value={name.label}
                                style={{ padding: "4px 0 4px 0" }}
                              >
                                <Checkbox
                                  checked={
                                    filterDocTypes.indexOf(name.label) > -1
                                  }
                                />
                                {name.label}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    */}

                                        <Grid item xs={12}>
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                onClick={saveFilter}
                                            >
                                                FILTER
                                            </Button>
                                            &nbsp;&nbsp;
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                onClick={resetFilter}
                                            >
                                                Reset
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
                {filteredList && filteredList.length > 0
                    ? filteredList
                        .filter((a) => a.type !== "stage1" && a.type !== "stage2" && a.type === fileType)
                        .map((res, index) => {
                            return (
                                <div key={index} style={{width: "100%", margin: "10px"}}>
                                    <Grid item xs={1}>
                                        <Chip
                                            size="small"
                                            variant="outlined"
                                            color="primary"
                                            label={`V${res.version}`}
                                        />
                                    </Grid>`
                                    <Grid item xs={12}>
                                        {res.status === "Y" ?
                                            <AttachmentChip
                                                key={index}
                                                id={res.file_seq}
                                                filename={res.filename}
                                                fileSize={res.filesize}
                                                fileExtension={res.extension}
                                                viewFileAction={() =>
                                                    viewFileAction("master", res.file_seq, res.filename)
                                                }
                                                downloadFileAction={() => {
                                                    downloadFileAction("master", res.file_seq);
                                                }}
                                                fileRemoveAction={!lock?() => {fileRemoveAction(res)}:null}
                                            />
                                            : <AttachmentDeletedChip
                                                key={index}
                                                id={res.file_seq}
                                                filename={res.filename}
                                                fileSize={res.filesize}
                                                fileExtension={res.extension}
                                            />

                                        }

                                    </Grid>
                                </div>
                            );
                        })
                    : ""}
            </Grid>

            <Box style={{textAlign: "center", minHeight: "75px"}}>
                {uploadable && !lock
                    ? <Tooltip title="Add File From Hard Disk">
                        <Fab
                            color="primary"
                            size="small"
                            aria-label="add_file"
                            className={classes.addFileBtn}
                            onClick={open}
                        >
                            <StorageIcon/>
                        </Fab>
                    </Tooltip>
                    : <></>
                }

            </Box>
        </Fragment>
    );
};

export default PilFileZoneContentSupportDoc;
